import Model from "../Model";

class Buttonssyncro extends Model{

    buildUrl ({ param }) {
        return ['synchro/get_group_type', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Buttonssyncro;